import React from 'react';
import { Dialog, DialogTitle, DialogContent, IconButton, Box, Typography, Divider, useMediaQuery } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import theme from '../../util/theme/theme';

interface AutoProvisionMetaModalProps {
    open: boolean;
    onClose: () => void;
    metadata: any;
}

const AutoProvisionMetaModal: React.FC<AutoProvisionMetaModalProps> = ({ open, onClose, metadata }) => {
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="sm"
            fullWidth
            PaperProps={{ sx: { borderRadius: isMobile ? 0 : 3 } }}
        >
            <DialogTitle sx={{ fontWeight: 700, fontSize: isMobile ? 16 : 20, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                Auto Provision Details
                <IconButton
                    onClick={onClose}
                    size="small"
                    sx={{ color: 'var(--color-text-muted)' }}
                >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent sx={{ pt: 2, px: isMobile ? 1 : 2 }}>
                {metadata && (
                    <Box>
                        <Box mb={2}>
                            <Typography sx={{ fontWeight: 600, fontSize: 12, color: 'var(--color-text-muted)', mb: 0.5 }}>Source</Typography>
                            <Typography sx={{ fontSize: 14 }}>{metadata.source || 'N/A'}</Typography>
                        </Box>
                        <Box mb={2}>
                            <Typography sx={{ fontWeight: 600, fontSize: 12, color: 'var(--color-text-muted)', mb: 0.5 }}>Pattern Method</Typography>
                            <Typography sx={{ fontSize: 14 }}>{metadata.patternMethod || 'N/A'}</Typography>
                        </Box>
                        <Box mb={2}>
                            <Typography sx={{ fontWeight: 600, fontSize: 12, color: 'var(--color-text-muted)', mb: 0.5 }}>Triggered By</Typography>
                            <Typography sx={{ fontSize: 14 }}>{metadata.triggeredBy || 'N/A'}</Typography>
                        </Box>
                        <Divider sx={{ my: 2 }} />
                        <Typography sx={{ fontWeight: 600, fontSize: 14, mb: 1 }}>Recurrence Analysis</Typography>
                        {metadata.recurrenceAnalysis && (
                            <Box sx={{ background: 'var(--color-container-background)', borderRadius: 2, p: 1.5 }}>
                                <Box mb={1}>
                                    <Typography sx={{ fontWeight: 500, fontSize: 12, color: 'var(--color-text-muted)' }}>Interval</Typography>
                                    <Typography sx={{ fontSize: 13 }}>{metadata.recurrenceAnalysis.interval}</Typography>
                                </Box>
                                <Box mb={1}>
                                    <Typography sx={{ fontWeight: 500, fontSize: 12, color: 'var(--color-text-muted)' }}>Amount</Typography>
                                    <Typography sx={{ fontSize: 13 }}>{metadata.recurrenceAnalysis.amount}</Typography>
                                </Box>
                                <Box mb={1}>
                                    <Typography sx={{ fontWeight: 500, fontSize: 12, color: 'var(--color-text-muted)' }}>Description</Typography>
                                    <Typography sx={{ fontSize: 13 }}>{metadata.recurrenceAnalysis.simplifiedDescription}</Typography>
                                </Box>
                                <Box mb={1}>
                                    <Typography sx={{ fontWeight: 500, fontSize: 12, color: 'var(--color-text-muted)' }}>Total Matches Found</Typography>
                                    <Typography sx={{ fontSize: 13 }}>{metadata.recurrenceAnalysis.totalMatchesFound}</Typography>
                                </Box>
                                {metadata.recurrenceAnalysis.suggestedCategoryId && (
                                    <Box>
                                        <Typography sx={{ fontWeight: 500, fontSize: 12, color: 'var(--color-text-muted)' }}>Suggested Category ID</Typography>
                                        <Typography sx={{ fontSize: 13 }}>{metadata.recurrenceAnalysis.suggestedCategoryId}</Typography>
                                    </Box>
                                )}
                            </Box>
                        )}
                    </Box>
                )}
            </DialogContent>
        </Dialog>
    );
};

export default AutoProvisionMetaModal;
